import React from "react";
import Header from "../../layout/Header/Header";
import Footer from "../../layout/Footer/Footer";
import imagenes from "../../assets/Imagenes";
import MostrarOptimo from "../Mostrar/MostrarOptimo";
import "../../styles/index.css"
import WhatsAppButton from "../../components/BtnWhatsapp/Whatsapp";


const Depto = () => {
	return (
		<>
			<Header />
			<section className="section-todas-pesnias">
			<img src={imagenes.op7} className="banner-todas-pestanias" alt="" />
			</section>

			<h1 className="titulo-h1">Departamentos</h1>
			<MostrarOptimo tipo="departamentos"/>
			<Footer />
		</>
	);
};

export default Depto;
/*

<Mostrar tipo="casa" />
<Mostrar tipo="departamento" />


*/